import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const PUBLIC_BASE_URL = process.env.REACT_APP_PUBLIC_BASE_URL;

export const getAllCertificates = createAsyncThunk(
    'certificate/getAllCertificates',
    async ({ skip, limit, search, status, course_id, certificate_entity_id, batch, certificate_type_id, certificate_template_id }, { rejectWithValue }) => {
        try {
            
            const params = {};
            if (skip !== undefined) params.skip = skip;
            if (limit !== undefined) params.limit = limit;
            if (search) params.search = search;
            if (status) params.certificate_status = status;
            if (course_id) params.course_id = course_id;
            if (certificate_entity_id) params.certificate_entity_id = certificate_entity_id;
            if (batch) params.batch = batch;
            if (certificate_type_id) params.certificate_type_id = certificate_type_id;
            if (certificate_template_id) params.certificate_template_id = certificate_template_id;

            const config = {
                headers: {
                    "Content-Type": "application/json",
                },
                withCredentials: true,
                params,
            };

            const response = await axios.get(`${PUBLIC_BASE_URL}/certificates`, config);
            return (response.data);

        } catch (err) {
            if (err.message === "Network Error") {
                return rejectWithValue({
                    response: {
                        data: {
                            message: "Network Error",
                            status: err.code,
                            statusText: err.code,
                        },
                    },
                });
            } else {
                return rejectWithValue(
                    err.response?.data?.message || 'An error occurred'
                );
            }
        }
    }
);

export const editCertificate = createAsyncThunk(
    'certificate/editCertificate',
    async (updatedData, { rejectWithValue }) => {
        try {

            const config = {
                headers: {
                    "Content-Type": "application/json",
                },
                withCredentials: true,
            };

            const body = JSON.stringify(updatedData);
            const response = await axios.put(`${PUBLIC_BASE_URL}/certificates/update-certificate-info`, body, config);
            return response.data;
        } catch (err) {
            if (err.message === "Network Error") {
                return rejectWithValue({
                    message: "Network Error",
                    status: err.code,
                    success: false
                });
            } else {
                return rejectWithValue(err.response?.data || 'Unknown error occurred.');
            }
        }
    }
);

export const verifyCertificate = createAsyncThunk(
    'certificate/verifyCertificate',
    async ({ document_ref }, { rejectWithValue }) => {
        try {
            const params = {};
            params.document_ref = document_ref;

            const config = {
                headers: {
                    "Content-Type": "application/json",
                },
                withCredentials: true,
                params,
            };

            const response = await axios.get(`${PUBLIC_BASE_URL}/certificates/verify`, config);
            return (response.data);

        } catch (err) {
            if (err.message === "Network Error") {
                return rejectWithValue({
                    response: {
                        data: {
                            message: "Network Error",
                            status: err.code,
                            statusText: err.code,
                        },
                    },
                });
            } else {
                return rejectWithValue(
                    err.response?.data?.message || 'An error occurred'
                );
            }
        }
    }
);

export const getCertificateById = createAsyncThunk(
    'certificate/getCertificateById',
    async ({ certificate_id }, { rejectWithValue }) => {
        try {
            const config = {
                headers: {
                    "Content-Type": "application/json",
                },
                withCredentials: true,
            };

            const response = await axios.get(`${PUBLIC_BASE_URL}/certificates/${certificate_id}`, config);
            return (response.data);

        } catch (err) {
            if (err.message === "Network Error") {
                return rejectWithValue({
                    response: {
                        data: {
                            message: "Network Error",
                            status: err.code,
                            statusText: err.code,
                        },
                    },
                });
            } else {
                return rejectWithValue(
                    err.response?.data?.message || 'An error occurred'
                );
            }
        }
    }
);

export const getAllCertificatesToBulkDownload = createAsyncThunk(
    'certificate/getAllCertificatesToBulkDownload',
    async ({ status, course_id }, { rejectWithValue }) => {
        try {
            const params = {};
            if (status) params.status = status;
            if (course_id) params.course_id = course_id;

            const config = {
                headers: {
                    "Content-Type": "application/json",
                },
                withCredentials: true,
                params,
            };

            const response = await axios.get(`${PUBLIC_BASE_URL}/certificates`, config);
            return (response.data);

        } catch (err) {
            if (err.message === "Network Error") {
                return rejectWithValue({
                    response: {
                        data: {
                            message: "Network Error",
                            status: err.code,
                            statusText: err.code,
                        },
                    },
                });
            } else {
                return rejectWithValue(
                    err.response?.data?.message || 'An error occurred'
                );
            }
        }
    }
);

export const editCertificateBulkStatus = createAsyncThunk(
    'certificate/editCertificateBulkStatus',
    async (updatedData, { rejectWithValue }) => {
        try {

            const config = {
                headers: {
                    "Content-Type": "application/json",
                },
                withCredentials: true,
            };

            const body = JSON.stringify(updatedData);
            const response = await axios.put(`${PUBLIC_BASE_URL}/certificates/bulk-action`, body, config);
            return response.data;
        } catch (err) {
            if (err.message === "Network Error") {
                return rejectWithValue({
                    message: "Network Error",
                    status: err.code,
                    success: false
                });
            } else {
                return rejectWithValue(err.response?.data || 'Unknown error occurred.');
            }
        }
    }
);
